export const LEGAL_AGE = 18
export const MAX_YEARS = 100
export const CURRENT_YEAR = new Date().getFullYear()
export const FROM_LEGAL_MONTH = new Date(CURRENT_YEAR - LEGAL_AGE, 0)
export const TO_LEGAL_MONTH = new Date(CURRENT_YEAR - MAX_YEARS - LEGAL_AGE, 11)
export const FROM_CURRENT_YEAR = new Date(CURRENT_YEAR, 0)
export const FROM_CURRENT_YEAR_MONTH = new Date(CURRENT_YEAR, new Date().getMonth())
export const TO_CURRENT_YEAR = new Date(CURRENT_YEAR - MAX_YEARS, 11)
